module.exports = __webpack_public_path__ + "img/23.d8b90c03.png";